import { useContext, useState } from "react";
import { useNotifications } from "sprint-common-web";

import { OrderRequestStatus } from "../../../../common/types/OrderRequestStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderRequestListingContext } from "../context/OrderRequestListingContext";
import { mapDetailsResponseToOrderRequestListingItem, OrderRequestListingItem } from "../OrderRequestListingItem";

export const useRefreshOrderRequest = (item: OrderRequestListingItem) => {
    const { updateOrderRequest, pinnedItems } = useContext(OrderRequestListingContext);
    const { refreshOrderRequest, getOrderRequestDetails } = useOrdersModuleApi();
    const { success, error: errorNotification } = useNotifications();

    const [isLoading, setLoading] = useState(false);

    const handleRefreshOrderRequest = () => {
        setLoading(true);
        refreshOrderRequest({ orderRequestId: item.id })
            .then(async () => {
                const orderRequestDetails = await getOrderRequestDetails({ orderRequestId: item.id });

                const mappedOrderRequestItem = mapDetailsResponseToOrderRequestListingItem(
                    orderRequestDetails.orderRequest,
                    pinnedItems
                );

                updateOrderRequest({
                    ...mappedOrderRequestItem,
                    id: item.id,
                    isModified: true
                });

                if (mappedOrderRequestItem.status === OrderRequestStatus.Pending) {
                    success("Refreshing order request completed successfully");
                } else {
                    errorNotification("Something went wrong while refreshing order request");
                }
            })
            .catch(() => {
                errorNotification("Something went wrong while refreshing order request");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return {
        handleRefreshOrderRequest,
        isLoading
    };
};
